import { u as P, T as n, ag as ne } from "./eMyAsurionProvider-d8e4d830.js";
import { q as ji, C as gi, D as ui, H as bi, L as yi, M as fi, n as Ii, o as wi, s as Ci, P as Si, r as Mi, S as Di, p as Ni } from "./eMyAsurionProvider-d8e4d830.js";
import { AvatarInitials as Li } from "./myasurion-shared.profile.es.js";
import { ProtectedLayout as Ti } from "./myasurion-shared.layout.es.js";
import { BackButton as Wi, SubHeader as Ai } from "./myasurion-shared.eheader.es.js";
import { TextInput as re } from "./myasurion-shared.forms.es.js";
import { Input as Pi } from "./myasurion-shared.forms.es.js";
import { Faq as Bi } from "./myasurion-shared.efaq.es.js";
import { DeviceCard as ki } from "./myasurion-shared.device.es.js";
import { HelloWorld as Ei } from "./myasurion-shared.message.es.js";
import { TextTranslation as Zi } from "./myasurion-shared.localization.es.js";
import { DeviceService as Hi } from "./myasurion-shared.services.es.js";
import { SubmitRequest as Xi } from "./myasurion-shared.esubmitRequest.es.js";
import { ReviewSubmission as Ji } from "./myasurion-shared.ereviewSubmission.es.js";
import { C as k, I as Q } from "./payment-a9583849.js";
import { P as qi } from "./payment-a9583849.js";
import { TermsAndCondition as et } from "./myasurion-shared.T_C.es.js";
import { Cards as tt } from "./myasurion-shared.ecards.es.js";
import { SmartStock as rt } from "./myasurion-shared.esmartStock.es.js";
import { DeviceSpecification as ot } from "./myasurion-shared.edeviceselection.es.js";
import { ConfirmationAfterSubmission as at } from "./myasurion-shared.confirmation.es.js";
import { DeliveryOptions as ct } from "./myasurion-shared.edeliveryOptions.es.js";
import { T as le } from "./elogisticsAndFulfilment-c4dbe920.js";
import { D as pt, L as ht, N as mt, P as jt, S as gt } from "./elogisticsAndFulfilment-c4dbe920.js";
import { Button as bt } from "./myasurion-shared.widgets.es.js";
import { DeviceModel as ft } from "./myasurion-shared.yourModel.es.js";
import { VideoDeclaration as wt, VideoPlayer as Ct } from "./myasurion-shared.evideoDeclaration.es.js";
import { SubmitDeclaration as Mt } from "./myasurion-shared.esubmitDeclaration.es.js";
import { TriageQuestion as Nt } from "./myasurion-shared.Triage.es.js";
import { NPS as Lt, NPSReasons as zt, NPSSlider as Tt } from "./myasurion-shared.enps.es.js";
import { j as e } from "./jsx-runtime-944c88e2.js";
import { Box as i, Text as t, Flex as u, Stack as G, Square as Z, Select as oe, Image as R, Input as q, Button as $, Accordion as se, AccordionItem as H, AccordionButton as Y, AccordionIcon as X, AccordionPanel as U, Tag as _, Circle as ae, FormControl as K, FormErrorMessage as V, RadioGroup as xe, Radio as ce } from "@chakra-ui/react";
import { CloseIcon as de } from "@chakra-ui/icons";
import { CSAT as Wt } from "./myasurion-shared.ecsat.es.js";
import "@tanstack/react-query";
import pe, { useEffect as he, useState as me } from "react";
import "./useAccount-2421e215.js";
import "./myasurion-shared.mixpanel.es.js";
import "./features-d3d4bb45.js";
import { C as $t } from "./providers-251f5186.js";
import "react-router-dom";
import { B as je, F as ee } from "./cleave-react-node-c4a374e5.js";
import "./lodash-9598aa3c.js";
import "@react-oauth/google";
import { T as J } from "./chunk-2OOHT3W5-81d8ab81.js";
import { ViewDocument as Kt } from "./myasurion-shared.emydocuments.es.js";
import { T as Vt } from "./TextEditIcon-56b71cbb.js";
import { P as Rt } from "./ProfileIcon-8cf21b72.js";
import { P as Gt } from "./PaymentCCIcon-d0999298.js";
import { GoogleSignInButton as Qt, OTPInput as Ht } from "./myasurion-shared.auth.es.js";
import "./domains-bf220bf9.js";
import "./myasurion-shared.carrier.es.js";
import "framer-motion";
import "./myasurion-shared.utils.es.js";
import "./myasurion-shared.colors.es.js";
import "@emotion/react";
import "react-dom";
import "./chunk-UVUR7MCU-c543fd79.js";
import "./index-d84e10ff.js";
import "./chunk-5PH6ULNP-da6977a4.js";
import "./chunk-DMO4EI7P-a11dff68.js";
import "./index-feffa1ce.js";
import "./index-5ae1d1e0.js";
import "./LockIcon-7635fee6.js";
import "./nps-reasons-1b4ba012.js";
import "./chunk-QINAG4RG-2921dd5f.js";
import "@emotion/styled";
const ge = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxnIGlkPSJmaWxlLXVwbG9hZC0xIj4NCjxnIGlkPSJWZWN0b3IiPg0KPHBhdGggZD0iTTggMTNMMTIgOUwxNiAxM0gxM1YxOEgxMVYxM0g4WiIgZmlsbD0iYmxhY2siLz4NCjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNSAxSDE2LjQxNEwyMSA1LjU4NlYyMUMyMSAyMi4xMDMgMjAuMTAzIDIzIDE5IDIzSDVDMy44OTcgMjMgMyAyMi4xMDMgMyAyMVYzQzMgMS44OTggMy44OTcgMSA1IDFaTTUgM1YyMUgxOS4wMDFMMTkgN0gxNVYzSDVaIiBmaWxsPSJibGFjayIvPg0KPC9nPg0KPC9nPg0KPC9zdmc+DQo=", _e = (g) => {
  const {
    title: x,
    updateDeviceText: j,
    updateDeviceQueLBL: f,
    updateDeviceOptions: d,
    uploadDocTextLBL: r,
    plan: s,
    mdn: p,
    model: b,
    imei: D,
    imageEl: I,
    placeHolder: w,
    optionPlaceHolder: C,
    onClickSubmit: a,
    isDisabled: y,
    handleFileUpload: M,
    btnSubmitLBL: o,
    handleOptions: c,
    moreThan5Mb: m,
    fileError: v,
    uploadFileText: z,
    hideUploadBtn: l,
    uploadedFileName: h,
    removeFile: N,
    serialNumber: T,
    fileErrorText: L,
    ...S
  } = g, W = "UpdateDevice", B = [
    { field: "mdn", label: "Mobile:", weight: 700 },
    { field: "model", label: "Model:" }
  ];
  T ? B.push({ field: "serialNumber", label: "Serial Number:" }) : B.push({ field: "imei", label: "IMEI:" });
  const { data: A } = P(), { theme: ie } = A, { colors: te } = ie;
  return /* @__PURE__ */ e.jsx(i, { children: /* @__PURE__ */ e.jsxs(
    i,
    {
      ...S,
      p: 4,
      alignItems: "center",
      w: { base: "full", lg: "70%" },
      margin: { base: "0", lg: "auto" },
      pb: { base: "0", lg: "140px" },
      children: [
        /* @__PURE__ */ e.jsx(i, { p: 2, children: x && /* @__PURE__ */ e.jsx(t, { fontSize: { base: "2xl", lg: "3xl" }, children: /* @__PURE__ */ e.jsx(n, { text: x, translationKey: `${W}/title` }) }) }),
        /* @__PURE__ */ e.jsx(
          i,
          {
            id: "myasurion-devicecard",
            borderRadius: "8px",
            minW: "335px",
            minH: "124px",
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "gray.300",
            p: "16px",
            ...S,
            children: /* @__PURE__ */ e.jsx(e.Fragment, { children: /* @__PURE__ */ e.jsxs(u, { justify: "space-between", children: [
              /* @__PURE__ */ e.jsxs(i, { width: "full", children: [
                /* @__PURE__ */ e.jsx(i, { width: "fit-content", m: "0", mb: "15px", children: /* @__PURE__ */ e.jsx(
                  i,
                  {
                    m: 0,
                    p: "4px",
                    bg: "brand.neutral.bright",
                    borderRadius: "2px",
                    children: /* @__PURE__ */ e.jsx(t, { fontSize: "sm", children: s })
                  }
                ) }),
                B.map((F, E) => /* @__PURE__ */ e.jsxs(
                  G,
                  {
                    direction: "row",
                    gap: 0,
                    spacing: 0,
                    w: "full",
                    fontSize: "md",
                    fontWeight: 400,
                    children: [
                      /* @__PURE__ */ e.jsx(i, { w: "30%", float: "left", fontWeight: "bold", children: /* @__PURE__ */ e.jsx(
                        n,
                        {
                          text: F.label,
                          translationKey: `${W}/${F.field}`
                        }
                      ) }),
                      /* @__PURE__ */ e.jsx(
                        i,
                        {
                          w: "70%",
                          float: "right",
                          fontWeight: F.weight || 400,
                          children: g[`${F.field}`]
                        }
                      )
                    ]
                  },
                  `devicecard-field-${F.field}-${E}`
                ))
              ] }),
              /* @__PURE__ */ e.jsx(Z, { children: I || /* @__PURE__ */ e.jsx(i, { m: "30% auto", fontSize: "xs", color: "gray.300", children: /* @__PURE__ */ e.jsx(
                n,
                {
                  text: "No image",
                  translationKey: `${W}/lblNoImage`
                }
              ) }) })
            ] }) })
          }
        ),
        /* @__PURE__ */ e.jsxs(i, { w: { base: "full", lg: "80%" }, m: "auto", children: [
          /* @__PURE__ */ e.jsxs(t, { fontWeight: "bold", mt: "5", children: [
            /* @__PURE__ */ e.jsx(
              n,
              {
                text: f,
                translationKey: `${W}/updateDeviceQueLBL`
              }
            ),
            /* @__PURE__ */ e.jsx("span", { style: { color: "red" }, children: "*" })
          ] }),
          /* @__PURE__ */ e.jsx(i, { mt: "2", children: /* @__PURE__ */ e.jsx(oe, { placeholder: C, onChange: (F) => c(F), children: d == null ? void 0 : d.map((F, E) => /* @__PURE__ */ e.jsx("option", { value: F, children: /* @__PURE__ */ e.jsx(t, { fontSize: { base: "2xl", lg: "3xl" }, children: /* @__PURE__ */ e.jsx(
            n,
            {
              text: F,
              translationKey: `${W}/${F}-${E}`
            }
          ) }) }, F)) }) }),
          /* @__PURE__ */ e.jsxs(t, { fontWeight: "bold", mt: "5", children: [
            /* @__PURE__ */ e.jsx(
              n,
              {
                text: r,
                translationKey: `${W}/uploadDocTextLBL`
              }
            ),
            /* @__PURE__ */ e.jsx("span", { style: { color: "red" }, children: "*" })
          ] }),
          l ? /* @__PURE__ */ e.jsx(e.Fragment, { children: /* @__PURE__ */ e.jsxs(u, { direction: "row", justify: "space-between", children: [
            h,
            /* @__PURE__ */ e.jsx(
              de,
              {
                onClick: () => N(),
                cursor: "pointer",
                alignSelf: "center",
                marginX: "0.5rem",
                padding: "1px"
              }
            )
          ] }) }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
            /* @__PURE__ */ e.jsxs(
              u,
              {
                mt: "2",
                direction: "row",
                alignContent: "center",
                border: "1px solid #6E767D",
                borderRadius: "xl",
                p: "2",
                position: "relative",
                children: [
                  /* @__PURE__ */ e.jsx(R, { src: ge, my: "auto", mx: "2" }),
                  /* @__PURE__ */ e.jsx(
                    q,
                    {
                      type: "file",
                      display: "hidden",
                      border: "none",
                      p: "5px 10px",
                      height: "auto",
                      placeholder: w,
                      onChange: (F) => M(F),
                      style: {
                        opacity: 0,
                        overflow: "hidden",
                        zIndex: 999
                      }
                    }
                  ),
                  /* @__PURE__ */ e.jsx(
                    "label",
                    {
                      style: {
                        position: "absolute",
                        top: "30%",
                        left: "15%",
                        zIndex: "0",
                        color: "#6E767D"
                      },
                      children: /* @__PURE__ */ e.jsx("span", { children: /* @__PURE__ */ e.jsx(
                        n,
                        {
                          text: z,
                          translationKey: `${W}/uploadFileText`
                        }
                      ) })
                    }
                  )
                ]
              }
            ),
            v && /* @__PURE__ */ e.jsx(t, { color: "red", fontSize: "14px", mt: "2px", align: "center", children: /* @__PURE__ */ e.jsx(
              n,
              {
                text: L || "Invalid file format, please upload a PDF/JPEG/jpg/png/bmp file.",
                translationKey: `${W}/updateDeviceInvalidFileFormatError`
              }
            ) }),
            m && /* @__PURE__ */ e.jsx(t, { color: "red", fontSize: "14px", mt: "2px", align: "center", children: /* @__PURE__ */ e.jsx(
              n,
              {
                text: "You can upload files maximum of 5 MB per file",
                translationKey: `${W}/updateDeviceFileSizeError`
              }
            ) })
          ] }),
          /* @__PURE__ */ e.jsx(i, { w: { base: "full", lg: "50%" }, m: "20px auto", children: /* @__PURE__ */ e.jsx(
            $,
            {
              w: "full",
              color: "white",
              colorScheme: "primary",
              bg: y ? "gray.200" : te.primary,
              cursor: y ? "not-allowed" : "pointer",
              disabled: y,
              onClick: () => y ? void 0 : a && a(),
              children: o && /* @__PURE__ */ e.jsx(n, { text: o, translationKey: "Global/Submit" })
            }
          ) })
        ] })
      ]
    }
  ) });
}, ei = (g) => {
  const {
    title: x,
    heading: j,
    mobileNoLbl: f,
    deviceNameLbl: d,
    imeiLbl: r,
    mobileNo: s,
    deviceName: p,
    imei: b,
    image: D,
    confirmText: I,
    makeModelLbl: w,
    capacityLbl: C,
    colorLbl: a,
    updatedImei: y,
    updatedDeviceName: M,
    updatedCapacityVal: o,
    updatedColorVal: c,
    onClickSubmit: m,
    btnSubmitLBL: v,
    imageEl: z,
    ...l
  } = g, h = "ReviewUpdateDevice";
  return P(), /* @__PURE__ */ e.jsx(i, { children: /* @__PURE__ */ e.jsxs(
    i,
    {
      ...l,
      p: 2,
      alignItems: "center",
      w: { base: "full", lg: "50%" },
      margin: { base: "0", lg: "auto" },
      pb: { base: "0", lg: "140px" },
      children: [
        /* @__PURE__ */ e.jsx(i, { children: x && /* @__PURE__ */ e.jsx(t, { fontSize: { base: "2xl", lg: "3xl" }, children: /* @__PURE__ */ e.jsx(n, { text: x, translationKey: `${h}/title` }) }) }),
        /* @__PURE__ */ e.jsxs(
          u,
          {
            backgroundColor: "#F0F0F5",
            width: "100%",
            p: 4,
            display: "flex",
            borderTopRadius: "lg",
            direction: "column",
            children: [
              /* @__PURE__ */ e.jsx(t, { fontSize: "20px", my: "2", children: /* @__PURE__ */ e.jsx(n, { text: j, translationKey: `${h}/heading` }) }),
              /* @__PURE__ */ e.jsxs(u, { direction: "row", justifyContent: "space-between", align: "center", children: [
                /* @__PURE__ */ e.jsxs(u, { direction: "column", children: [
                  /* @__PURE__ */ e.jsxs(u, { direction: "row", mr: 4, children: [
                    /* @__PURE__ */ e.jsxs(t, { minW: "60px", children: [
                      /* @__PURE__ */ e.jsx(
                        n,
                        {
                          text: f,
                          translationKey: `${h}/mobileNoLbl`
                        }
                      ),
                      ":"
                    ] }),
                    /* @__PURE__ */ e.jsx(t, { fontWeight: "700", children: s })
                  ] }),
                  /* @__PURE__ */ e.jsxs(u, { direction: "row", mr: 4, children: [
                    /* @__PURE__ */ e.jsxs(t, { minW: "60px", children: [
                      /* @__PURE__ */ e.jsx(
                        n,
                        {
                          text: d,
                          translationKey: `${h}/deviceNameLbl`
                        }
                      ),
                      ":"
                    ] }),
                    p
                  ] }),
                  /* @__PURE__ */ e.jsxs(u, { direction: "row", mr: 4, children: [
                    /* @__PURE__ */ e.jsxs(t, { minW: "60px", children: [
                      /* @__PURE__ */ e.jsx(
                        n,
                        {
                          text: r,
                          translationKey: `${h}/imeiLbl`
                        }
                      ),
                      ":"
                    ] }),
                    b
                  ] })
                ] }),
                /* @__PURE__ */ e.jsx(i, { children: /* @__PURE__ */ e.jsx(Z, { children: z || /* @__PURE__ */ e.jsx(i, { m: "30% auto", fontSize: "xs", color: "gray.300", children: /* @__PURE__ */ e.jsx(
                  n,
                  {
                    text: "No image",
                    translationKey: `${h}/lblNoImage`
                  }
                ) }) }) })
              ] })
            ]
          }
        ),
        /* @__PURE__ */ e.jsx(t, { mt: "3", children: /* @__PURE__ */ e.jsx(n, { text: I, translationKey: `${h}/confirmText` }) }),
        /* @__PURE__ */ e.jsxs(i, { mt: "3", children: [
          /* @__PURE__ */ e.jsx(t, { fontWeight: "700", children: /* @__PURE__ */ e.jsx(n, { text: r, translationKey: `${h}/imeiLbl` }) }),
          y
        ] }),
        /* @__PURE__ */ e.jsxs(i, { mt: "3", children: [
          /* @__PURE__ */ e.jsx(t, { fontWeight: "700", children: /* @__PURE__ */ e.jsx(
            n,
            {
              text: w,
              translationKey: `${h}/makeModelLbl`
            }
          ) }),
          M
        ] }),
        /* @__PURE__ */ e.jsxs(i, { mt: "3", children: [
          /* @__PURE__ */ e.jsx(t, { fontWeight: "700", children: /* @__PURE__ */ e.jsx(n, { text: C, translationKey: `${h}/capacityLbl` }) }),
          o
        ] }),
        /* @__PURE__ */ e.jsxs(i, { mt: "3", children: [
          /* @__PURE__ */ e.jsx(t, { fontWeight: "700", children: /* @__PURE__ */ e.jsx(n, { text: a, translationKey: `${h}/colorLbl` }) }),
          c
        ] }),
        /* @__PURE__ */ e.jsx(i, { w: { base: "full", lg: "70%" }, m: "auto", mt: "5", children: /* @__PURE__ */ e.jsx(i, { w: { base: "full", lg: "50%" }, m: "auto", children: /* @__PURE__ */ e.jsx(
          $,
          {
            w: "full",
            color: "white",
            colorScheme: "primary",
            onClick: () => m && m(),
            children: v && /* @__PURE__ */ e.jsx(n, { text: v, translationKey: "Global/Submit" })
          }
        ) }) })
      ]
    }
  ) });
}, ii = (g) => {
  const {
    title: x,
    imeiPlaceholder: j,
    imeiValue: f,
    findImeiQue: d,
    iosTitle: r,
    iosHeading: s,
    iosInstruciton: p,
    androidTitle: b,
    androidHeading: D,
    androidInstruciton: I,
    onClickSubmit: w,
    handleImeiChange: C,
    btnSubmitLBL: a,
    isDisabled: y,
    invalidImei: M,
    ...o
  } = g, c = "ImeiDetails", { data: m } = P(), { theme: v } = m, { colors: z } = v;
  return /* @__PURE__ */ e.jsx(i, { children: /* @__PURE__ */ e.jsxs(
    i,
    {
      ...o,
      p: 2,
      alignItems: "center",
      w: { base: "full", lg: "50%" },
      margin: { base: "0", lg: "auto" },
      pb: { base: "0", lg: "140px" },
      children: [
        /* @__PURE__ */ e.jsx(i, { children: x && /* @__PURE__ */ e.jsx(t, { fontSize: { base: "2xl", lg: "3xl" }, children: /* @__PURE__ */ e.jsx(n, { text: x, translationKey: `${c}/title` }) }) }),
        /* @__PURE__ */ e.jsxs(i, { children: [
          /* @__PURE__ */ e.jsx(
            q,
            {
              size: "lg",
              type: "text",
              mt: 3,
              h: "50px",
              borderColor: "#6E767D",
              max: 15,
              _placeholder: { fontSize: "16px" },
              placeholder: j,
              onChange: (l) => C && C(l)
            }
          ),
          M && /* @__PURE__ */ e.jsx(t, { color: "red", children: /* @__PURE__ */ e.jsx(
            n,
            {
              text: "Please check your IMEI number and re-enter the correct IMEI number.",
              translationKey: `${c}/imeiError`
            }
          ) })
        ] }),
        /* @__PURE__ */ e.jsx(i, { mt: "5", children: d && /* @__PURE__ */ e.jsx(t, { fontSize: { base: "2xl", lg: "3xl" }, children: /* @__PURE__ */ e.jsx(
          n,
          {
            text: d,
            translationKey: `${c}/findImeiQue`
          }
        ) }) }),
        /* @__PURE__ */ e.jsxs(se, { allowToggle: !0, width: "100%", children: [
          /* @__PURE__ */ e.jsx(H, { py: "6", border: "none", children: ({ isExpanded: l }) => /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
            /* @__PURE__ */ e.jsxs(
              Y,
              {
                background: "inherit",
                _hover: { background: "inherit", border: "none" },
                p: 0,
                alignItems: "baseline",
                children: [
                  /* @__PURE__ */ e.jsx(i, { as: "span", flex: "1", textAlign: "left", children: /* @__PURE__ */ e.jsx(
                    t,
                    {
                      as: "b",
                      fontSize: "18px",
                      fontWeight: l ? 700 : "normal",
                      children: /* @__PURE__ */ e.jsx(
                        n,
                        {
                          text: r,
                          translationKey: `${c}/iosTitle`
                        }
                      )
                    }
                  ) }),
                  /* @__PURE__ */ e.jsx(X, {})
                ]
              }
            ),
            /* @__PURE__ */ e.jsxs(U, { px: 0, children: [
              /* @__PURE__ */ e.jsx(
                t,
                {
                  as: "b",
                  fontSize: "18px",
                  fontWeight: l ? 700 : "normal",
                  children: /* @__PURE__ */ e.jsx(
                    n,
                    {
                      text: s,
                      translationKey: `${c}/iosHeading`
                    }
                  )
                }
              ),
              /* @__PURE__ */ e.jsx("ol", { style: { listStyle: "none" }, children: p == null ? void 0 : p.map((h, N) => /* @__PURE__ */ e.jsx("li", { style: { paddingTop: "8px" }, children: /* @__PURE__ */ e.jsxs(u, { direction: "row", children: [
                /* @__PURE__ */ e.jsxs(i, { display: "inline-block", width: "1em", children: [
                  N + 1,
                  "."
                ] }),
                /* @__PURE__ */ e.jsx(t, { fontSize: "14px", children: /* @__PURE__ */ e.jsx(
                  n,
                  {
                    text: h,
                    translationKey: `${c}/iosInstruciton${N + 1}`
                  }
                ) })
              ] }) })) })
            ] })
          ] }) }, "accordion-item-faq"),
          /* @__PURE__ */ e.jsx(H, { py: "6", children: ({ isExpanded: l }) => /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
            /* @__PURE__ */ e.jsxs(
              Y,
              {
                background: "inherit",
                _hover: { background: "inherit", border: "none" },
                p: 0,
                alignItems: "baseline",
                children: [
                  /* @__PURE__ */ e.jsx(i, { as: "span", flex: "1", textAlign: "left", children: /* @__PURE__ */ e.jsx(
                    t,
                    {
                      as: "b",
                      fontSize: "18px",
                      fontWeight: l ? 700 : "normal",
                      children: /* @__PURE__ */ e.jsx(
                        n,
                        {
                          text: b,
                          translationKey: `${c}/androidTitle`
                        }
                      )
                    }
                  ) }),
                  /* @__PURE__ */ e.jsx(X, {})
                ]
              }
            ),
            /* @__PURE__ */ e.jsxs(U, { px: 0, children: [
              /* @__PURE__ */ e.jsx(
                t,
                {
                  as: "b",
                  fontSize: "18px",
                  fontWeight: l ? 700 : "normal",
                  children: /* @__PURE__ */ e.jsx(
                    n,
                    {
                      text: D,
                      translationKey: `${c}/androidHeading`
                    }
                  )
                }
              ),
              /* @__PURE__ */ e.jsx("ol", { style: { listStyle: "none" }, children: I == null ? void 0 : I.map((h, N) => /* @__PURE__ */ e.jsx("li", { style: { paddingTop: "8px" }, children: /* @__PURE__ */ e.jsxs(u, { direction: "row", children: [
                /* @__PURE__ */ e.jsxs(i, { display: "inline-block", width: "1em", children: [
                  N + 1,
                  "."
                ] }),
                /* @__PURE__ */ e.jsx(t, { fontSize: "14px", children: /* @__PURE__ */ e.jsx(
                  n,
                  {
                    text: h,
                    translationKey: `${c}/androidInstruciton${N + 1}`
                  }
                ) })
              ] }) })) })
            ] })
          ] }) }, "accordion-item-faq")
        ] }),
        /* @__PURE__ */ e.jsx(i, { w: { base: "full", lg: "70%" }, m: "auto", mt: "5", children: /* @__PURE__ */ e.jsx(i, { w: { base: "full", lg: "50%" }, m: "auto", children: /* @__PURE__ */ e.jsx(
          $,
          {
            w: "full",
            color: "white",
            colorScheme: "primary",
            bg: y ? "gray.200" : z.primary,
            cursor: y ? "not-allowed" : "pointer",
            isDisabled: y,
            onClick: () => w && w(),
            children: a && /* @__PURE__ */ e.jsx(n, { text: a, translationKey: "Global/Submit" })
          }
        ) }) })
      ]
    }
  ) });
}, ti = (g) => {
  const { title: x, descText: j, onClickSubmit: f, btnSubmitLBL: d, ...r } = g, s = "ImeiConfirmation";
  return P(), /* @__PURE__ */ e.jsx(i, { children: /* @__PURE__ */ e.jsxs(
    i,
    {
      ...r,
      p: 2,
      alignItems: "center",
      w: { base: "full", lg: "50%" },
      margin: { base: "0", lg: "auto" },
      pb: { base: "0", lg: "140px" },
      children: [
        /* @__PURE__ */ e.jsx(i, { children: x && /* @__PURE__ */ e.jsx(t, { fontSize: { base: "2xl", lg: "3xl" }, children: /* @__PURE__ */ e.jsx(n, { text: x, translationKey: `${s}/title` }) }) }),
        /* @__PURE__ */ e.jsx(i, { mt: "5", children: j && /* @__PURE__ */ e.jsx(t, { children: /* @__PURE__ */ e.jsx(n, { text: j, translationKey: `${s}/descText` }) }) }),
        /* @__PURE__ */ e.jsx(i, { w: { base: "full", lg: "70%" }, m: "auto", mt: "5", children: /* @__PURE__ */ e.jsx(i, { w: { base: "full", lg: "50%" }, m: "auto", children: /* @__PURE__ */ e.jsx(
          $,
          {
            w: "full",
            color: "white",
            colorScheme: "primary",
            onClick: () => f && f(),
            children: d && /* @__PURE__ */ e.jsx(
              n,
              {
                text: d,
                translationKey: "Global/CloseThisPage"
              }
            )
          }
        ) }) })
      ]
    }
  ) });
}, ni = ({
  onClickCallback: g,
  storageOptions: x,
  selectedCapacity: j,
  modelName: f,
  children: d,
  handleNext: r,
  isDisabled: s,
  ...p
}) => {
  const b = "SelectCapacity", { data: D } = P(), { theme: I } = D, { colors: w } = I;
  return /* @__PURE__ */ e.jsxs(i, { ...p, display: "flex", flexDirection: "column", height: "100%", children: [
    /* @__PURE__ */ e.jsx(
      i,
      {
        bg: "white",
        style: { boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.08)" },
        pt: "4",
        px: "4",
        pb: "2",
        children: /* @__PURE__ */ e.jsx(t, { fontWeight: "bold", children: f })
      }
    ),
    /* @__PURE__ */ e.jsx(i, { display: "flex", justifyContent: "space-between", alignItems: "center", pt: "24px", px: "4", children: /* @__PURE__ */ e.jsx(t, { fontSize: "2rem", fontWeight: "300", children: /* @__PURE__ */ e.jsx(
      n,
      {
        text: "Select capacity",
        translationKey: `${b}/selectCapacity`
      }
    ) }) }),
    /* @__PURE__ */ e.jsx(i, { overflowY: "auto", flex: "1", children: x == null ? void 0 : x.map((C, a) => /* @__PURE__ */ e.jsx(
      _,
      {
        width: "full",
        padding: 4,
        my: 4,
        border: j == C ? `2px solid ${w == null ? void 0 : w.accent}` : "1px solid #A5AAAF",
        fontWeight: 700,
        background: "#FFFFFF",
        onClick: () => {
          g && g(C);
        },
        children: /* @__PURE__ */ e.jsx(
          t,
          {
            px: 4,
            justifyContent: "center",
            alignItems: "center",
            mx: "auto",
            children: C == 1 ? `${C}TB` : `${C}GB`
          }
        )
      },
      `capacity=${a}`
    )) }),
    /* @__PURE__ */ e.jsx(
      i,
      {
        bg: "white",
        style: { boxShadow: "0px -4px 4px 0px rgba(0, 0, 0, 0.08)" },
        py: "6",
        px: "4",
        children: /* @__PURE__ */ e.jsx(
          $,
          {
            onClick: () => r(),
            width: "full",
            bg: s ? "gray.200" : w.primary,
            cursor: s ? "not-allowed" : "pointer",
            disabled: s,
            textColor: "white",
            children: /* @__PURE__ */ e.jsx(n, { text: "Next", translationKey: `${b}/next` })
          }
        )
      }
    )
  ] });
}, ri = ({
  onClickCallback: g,
  colorOptions: x,
  selectedColor: j,
  modelName: f,
  children: d,
  handleNext: r,
  isDisabled: s,
  ...p
}) => {
  const b = "SelectColor", { data: D } = P(), { theme: I } = D, { colors: w } = I, C = (a) => {
    const y = {
      "light blue": "#ADD8E6",
      "jet black": "#0A0A0A",
      gold: "#FAD8BD",
      "beige/cream": "#F5F5DC",
      glow: "#FCE29A",
      "sierra blue": "#9BB5CE",
      midnight: "#171E27",
      green: "#364935",
      "light purple": "#D1CDDA",
      coral: "#EE7762",
      "light green": "#AEE1CD",
      silver: "#E7E7E7",
      "alpine green": "#3A6436",
      graphite: "#41424C",
      sierablue: "#BFDAF7"
    }, M = a.toLowerCase();
    return M in y ? y[M] : "#FCE29A";
  };
  return /* @__PURE__ */ e.jsxs(i, { ...p, display: "flex", flexDirection: "column", height: "100%", children: [
    /* @__PURE__ */ e.jsx(
      i,
      {
        bg: "white",
        style: { boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.08)" },
        pt: "4",
        px: "4",
        pb: "2",
        children: /* @__PURE__ */ e.jsx(t, { fontWeight: "bold", children: f })
      }
    ),
    /* @__PURE__ */ e.jsx(i, { display: "flex", justifyContent: "space-between", alignItems: "center", pt: "24px", px: "4", children: /* @__PURE__ */ e.jsx(t, { fontSize: "2rem", fontWeight: "300", children: /* @__PURE__ */ e.jsx(n, { text: "Select color", translationKey: `${b}/selectColor` }) }) }),
    /* @__PURE__ */ e.jsx(i, { overflowY: "auto", flex: "1", children: x == null ? void 0 : x.map((a, y) => /* @__PURE__ */ e.jsx(
      _,
      {
        width: "100px",
        height: "100px",
        padding: "9px",
        margin: "7px",
        border: j == a ? `2px solid ${w == null ? void 0 : w.accent}` : "1px solid #A5AAAF",
        fontWeight: 700,
        background: "#FFFFFF",
        onClick: () => {
          g && g(a);
        },
        children: /* @__PURE__ */ e.jsxs(G, { margin: "auto", minWidth: "max-content", alignItems: "center", children: [
          /* @__PURE__ */ e.jsx(
            ae,
            {
              borderWidth: a.toLowerCase() == "white" ? "1px" : "0px",
              borderRadius: "50%",
              borderColor: "gray.500",
              backgroundColor: a.toLowerCase() == "gold" || a.toLowerCase() == "silver" || a.toLowerCase() == "alpine green" || a.toLowerCase() == "graphite" || a.toLowerCase() == "sierablue" ? C(a) : ne(a) || C(a),
              size: "28px"
            }
          ),
          /* @__PURE__ */ e.jsx(t, { fontWeight: "700", children: /* @__PURE__ */ e.jsx(n, { text: a, translationKey: `${b}/${a}` }) })
        ] })
      },
      `color=${y}`
    )) }),
    /* @__PURE__ */ e.jsx(
      i,
      {
        bg: "white",
        style: { boxShadow: "0px -4px 4px 0px rgba(0, 0, 0, 0.08)" },
        py: "6",
        px: "4",
        children: /* @__PURE__ */ e.jsx(
          $,
          {
            onClick: () => r(),
            width: "full",
            bg: s ? "gray.200" : w.primary,
            cursor: s ? "not-allowed" : "pointer",
            disabled: s,
            textColor: "white",
            children: /* @__PURE__ */ e.jsx(n, { text: "Next", translationKey: `${b}/next` })
          }
        )
      }
    )
  ] });
}, li = ({
  newAddressQuestion: g,
  fields: x,
  handleInputChange: j,
  ...f
}) => /* @__PURE__ */ e.jsx(e.Fragment, { children: /* @__PURE__ */ e.jsxs(je, { mx: 4, mt: 6, fontFamily: "Apercu Pro", children: [
  /* @__PURE__ */ e.jsx(J, { fontSize: "md", fontWeight: 700, mb: 4, children: g }),
  /* @__PURE__ */ e.jsx(
    ee,
    {
      direction: { base: "column", lg: "row" },
      wrap: "wrap",
      justifyContent: { base: "start", lg: "space-between" },
      children: x.map((d) => /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        d.label && /* @__PURE__ */ e.jsx(J, { fontWeight: "bold", pb: 2, children: d.label }),
        /* @__PURE__ */ e.jsxs(
          K,
          {
            isRequired: d.isRequired,
            isInvalid: d.isInvalid,
            w: { base: "full", lg: "48%" },
            mb: 4,
            children: [
              /* @__PURE__ */ e.jsx(
                le,
                {
                  type: "text",
                  showIcon: !1,
                  borderColor: "#A5AAAF",
                  placeholder: d.placeholder,
                  value: d.value,
                  maxLength: 40,
                  onChange: (r) => {
                    j(d.name, r.value);
                  }
                }
              ),
              d.isInvalid && /* @__PURE__ */ e.jsx(V, { children: d.errorMessage })
            ]
          },
          d.name
        )
      ] }))
    }
  )
] }) }), oi = (g) => {
  const {
    pageTitle: x,
    subscribedDevices: j,
    title: f,
    heading: d,
    cardNumber: r,
    // imageEl,
    cardImage: s,
    changeText: p,
    nextBillingDateLBL: b,
    nextBillingDateValue: D,
    lastPaymentLBL: I,
    lastPaymentDate: w,
    lastPaymentFee: C,
    selectedDevice: a,
    handleSubscribedDevice: y,
    handleChange: M,
    ...o
  } = g, c = "MyPayments", { data: m } = P(), { theme: v } = m, { colors: z } = v;
  return /* @__PURE__ */ e.jsx(i, { children: /* @__PURE__ */ e.jsxs(
    i,
    {
      ...o,
      p: 2,
      alignItems: "center",
      w: { base: "full", lg: "70%" },
      margin: { base: "0", lg: "auto" },
      pb: { base: "0", lg: "20px" },
      children: [
        /* @__PURE__ */ e.jsx(i, { my: 1, children: x && /* @__PURE__ */ e.jsx(t, { fontSize: "24px", children: /* @__PURE__ */ e.jsx(n, { text: x, translationKey: `${c}/pageTitle` }) }) }),
        j.map((l, h) => /* @__PURE__ */ e.jsxs(
          u,
          {
            cursor: "pointer",
            direction: "row",
            justify: "space-between",
            borderRadius: "8px",
            minW: "335px",
            minH: "124px",
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: (a == null ? void 0 : a.mdn) === (l == null ? void 0 : l.mdn) ? "black" : "gray.300",
            p: "16px",
            mt: "4",
            onClick: () => y(l),
            children: [
              /* @__PURE__ */ e.jsxs(
                u,
                {
                  direction: "column",
                  w: "60%",
                  fontSize: "md",
                  fontWeight: 400,
                  children: [
                    /* @__PURE__ */ e.jsx(i, { m: "0", mb: "15px", children: /* @__PURE__ */ e.jsx(
                      i,
                      {
                        m: 0,
                        p: "4px",
                        bg: "brand.neutral.bright",
                        borderRadius: "2px",
                        children: /* @__PURE__ */ e.jsx(t, { fontSize: "sm", children: /* @__PURE__ */ e.jsx(
                          n,
                          {
                            text: l == null ? void 0 : l.plan,
                            translationKey: `Global/${l == null ? void 0 : l.plan}`
                          }
                        ) })
                      }
                    ) }),
                    /* @__PURE__ */ e.jsxs(i, { children: [
                      /* @__PURE__ */ e.jsx(i, { w: "30%", float: "left", children: /* @__PURE__ */ e.jsx(
                        n,
                        {
                          text: "Mobile:",
                          translationKey: `${c}/Mobile`
                        }
                      ) }),
                      /* @__PURE__ */ e.jsx(i, { w: "70%", float: "right", fontWeight: 700, children: l.mdn })
                    ] }),
                    /* @__PURE__ */ e.jsxs(i, { children: [
                      /* @__PURE__ */ e.jsx(i, { w: "30%", float: "left", children: /* @__PURE__ */ e.jsx(
                        n,
                        {
                          text: "Model:",
                          translationKey: `${c}/Model`
                        }
                      ) }),
                      /* @__PURE__ */ e.jsx(i, { w: "70%", float: "right", fontWeight: 400, children: l.model })
                    ] }),
                    /* @__PURE__ */ e.jsxs(i, { children: [
                      /* @__PURE__ */ e.jsx(i, { w: "30%", float: "left", children: /* @__PURE__ */ e.jsx(
                        n,
                        {
                          text: "IMEI:",
                          translationKey: `${c}/IMEI`
                        }
                      ) }),
                      /* @__PURE__ */ e.jsx(i, { w: "70%", float: "right", fontWeight: 400, children: l.imei })
                    ] })
                  ]
                },
                `devicecard-field-${l[h]}-${h}`
              ),
              /* @__PURE__ */ e.jsx(Z, { children: l != null && l.imageUrl ? /* @__PURE__ */ e.jsx(
                i,
                {
                  h: "full",
                  minH: "80px",
                  minW: "70px",
                  bgImage: `url(${l == null ? void 0 : l.imageUrl})`,
                  bgRepeat: "no-repeat",
                  bgPosition: "center center",
                  bgSize: "contain",
                  flexGrow: 1
                }
              ) : /* @__PURE__ */ e.jsx(i, { m: "30% auto", fontSize: "xs", color: "gray.300", children: /* @__PURE__ */ e.jsx(
                n,
                {
                  text: "No image",
                  translationKey: `${c}/lblNoImage`
                }
              ) }) })
            ]
          }
        )),
        /* @__PURE__ */ e.jsx(
          "hr",
          {
            style: {
              margin: "12px 0px",
              border: "none",
              borderTop: "1.5px solid #adaaaa"
            }
          }
        ),
        /* @__PURE__ */ e.jsx(i, { mb: 1, children: f && /* @__PURE__ */ e.jsx(t, { fontSize: { base: "20px", lg: "24px" }, fontWeight: "400", children: /* @__PURE__ */ e.jsx(n, { text: f, translationKey: `${c}/title` }) }) }),
        /* @__PURE__ */ e.jsx(i, { my: 1, children: d && /* @__PURE__ */ e.jsx(t, { fontWeight: "700", fontSize: "16px", children: /* @__PURE__ */ e.jsx(n, { text: d, translationKey: `${c}/heading` }) }) }),
        /* @__PURE__ */ e.jsx(i, { my: 1, children: /* @__PURE__ */ e.jsxs(u, { direction: "row", justify: "space-between", children: [
          /* @__PURE__ */ e.jsxs(u, { direction: "row", children: [
            /* @__PURE__ */ e.jsx(t, { fontSize: "16px", children: r }),
            s && s
          ] }),
          /* @__PURE__ */ e.jsx(
            t,
            {
              fontWeight: "700",
              fontSize: "16px",
              textDecorationLine: "underline",
              color: z.primary,
              cursor: "pointer",
              onClick: (l) => M(l),
              children: /* @__PURE__ */ e.jsx(
                n,
                {
                  text: p,
                  translationKey: `${c}/changeText`
                }
              )
            }
          )
        ] }) }),
        /* @__PURE__ */ e.jsx(i, { mt: 3, children: /* @__PURE__ */ e.jsx(t, { fontWeight: "700", fontSize: "16px", children: /* @__PURE__ */ e.jsx(
          n,
          {
            text: b,
            translationKey: `${c}/nextBillingDateLBL`
          }
        ) }) }),
        /* @__PURE__ */ e.jsx(i, { children: /* @__PURE__ */ e.jsx(t, { fontSize: "16px", children: D }) }),
        /* @__PURE__ */ e.jsx(i, { mt: 3, children: /* @__PURE__ */ e.jsx(t, { fontWeight: "700", fontSize: "16px", children: /* @__PURE__ */ e.jsx(
          n,
          {
            text: I,
            translationKey: `${c}/lastPaymentLBL`
          }
        ) }) }),
        /* @__PURE__ */ e.jsx(i, { children: /* @__PURE__ */ e.jsxs(t, { fontSize: "16px", children: [
          w,
          " ",
          C
        ] }) })
      ]
    }
  ) });
}, si = (g) => {
  const {
    pageTitle: x,
    mdn: j,
    plan: f,
    priceLBL: d,
    priceValue: r,
    nextBillingDateLBL: s,
    nextBillingDateValue: p,
    headingBillingHistory: b,
    viewAllLBL: D,
    viewInvoicesText: I = "View Invoices",
    paymentDateLBL: w,
    amountLBL: C,
    statusLBL: a,
    billingHistoryData: y,
    payNowBtnLBL: M,
    handlePaynow: o,
    handleChange: c,
    handleViewInvoices: m,
    handleMyDocuments: v,
    billingDesc: z,
    ...l
  } = g, h = "BillingDetails", { data: N } = P(), { theme: T } = N, { colors: L } = T;
  return /* @__PURE__ */ e.jsx(i, { children: /* @__PURE__ */ e.jsxs(
    i,
    {
      ...l,
      p: 2,
      alignItems: "center",
      w: "full",
      margin: { base: "0", lg: "auto" },
      pb: { base: "0", lg: "140px" },
      children: [
        /* @__PURE__ */ e.jsx(i, { my: 1, children: x && /* @__PURE__ */ e.jsx(t, { fontSize: { base: "20px", lg: "24px" }, children: /* @__PURE__ */ e.jsx(n, { text: x, translationKey: `${h}/pageTitle` }) }) }),
        /* @__PURE__ */ e.jsx(i, { my: 1, children: f && /* @__PURE__ */ e.jsx(t, { children: /* @__PURE__ */ e.jsx(n, { text: f, translationKey: `Global/${f}` }) }) }),
        /* @__PURE__ */ e.jsx(i, { fontWeight: "700", my: 1, fontSize: "24px", children: /* @__PURE__ */ e.jsx(t, { children: j }) }),
        /* @__PURE__ */ e.jsxs(u, { direction: "row", justify: "space-between", children: [
          /* @__PURE__ */ e.jsxs(u, { direction: "column", children: [
            /* @__PURE__ */ e.jsx(t, { fontWeight: "700", children: /* @__PURE__ */ e.jsx(n, { text: d, translationKey: `${h}/priceLBL` }) }),
            /* @__PURE__ */ e.jsx(t, { children: r })
          ] }),
          /* @__PURE__ */ e.jsxs(u, { direction: "column", children: [
            /* @__PURE__ */ e.jsx(t, { fontWeight: "700", children: /* @__PURE__ */ e.jsx(
              n,
              {
                text: s,
                translationKey: `${h}/nextBillingDateLBL`
              }
            ) }),
            /* @__PURE__ */ e.jsx(t, { children: p })
          ] })
        ] }),
        /* @__PURE__ */ e.jsx(t, { color: "#6E767D", my: "2", fontSize: "14px", children: /* @__PURE__ */ e.jsx(n, { text: z, translationKey: `${h}/billingDesc` }) }),
        /* @__PURE__ */ e.jsx(
          "hr",
          {
            style: {
              margin: "8px 0px 12px",
              border: "none",
              borderTop: "1px solid #adaaaa"
            }
          }
        ),
        /* @__PURE__ */ e.jsxs(u, { direction: "row", justify: "space-between", my: 3, children: [
          /* @__PURE__ */ e.jsx(t, { fontWeight: "400", fontSize: "24px", children: /* @__PURE__ */ e.jsx(
            n,
            {
              text: b,
              translationKey: `${h}/headingBillingHistory`
            }
          ) }),
          /* @__PURE__ */ e.jsxs(u, { direction: "row", children: [
            /* @__PURE__ */ e.jsx(
              t,
              {
                textDecorationLine: "underline",
                color: L.primary,
                cursor: "pointer",
                onClick: (S) => c(S),
                children: /* @__PURE__ */ e.jsx(
                  n,
                  {
                    text: D,
                    translationKey: `${h}/viewAllLBL`
                  }
                )
              }
            ),
            /* @__PURE__ */ e.jsx(
              t,
              {
                textDecorationLine: "underline",
                color: L.primary,
                cursor: "pointer",
                onClick: (S) => m(S),
                ml: "3",
                children: /* @__PURE__ */ e.jsx(
                  n,
                  {
                    text: I,
                    translationKey: `${h}/viewInvoicesText`
                  }
                )
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ e.jsx(i, { children: y == null ? void 0 : y.map((S, W) => {
          var B, A;
          return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
            /* @__PURE__ */ e.jsxs(
              u,
              {
                direction: "row",
                justify: "space-between",
                alignItems: "center",
                onClick: () => v(S),
                cursor: "pointer",
                children: [
                  /* @__PURE__ */ e.jsxs(t, { fontSize: { base: "14px", lg: "16px" }, children: [
                    /* @__PURE__ */ e.jsx(t, { fontWeight: "700", my: "1", children: S.paymentDate }),
                    S.paymentDuration
                  ] }),
                  /* @__PURE__ */ e.jsx(
                    t,
                    {
                      fontSize: { base: "14px", lg: "16px" },
                      color: ((B = S == null ? void 0 : S.status) == null ? void 0 : B.toLowerCase()) === "paid" ? "green" : "red",
                      children: S.status
                    }
                  )
                ]
              },
              W
            ),
            ((A = S == null ? void 0 : S.status) == null ? void 0 : A.toLowerCase()) !== "paid" && (S == null ? void 0 : S.ChargeOrderTypeCode) === "ENRFEE" && /* @__PURE__ */ e.jsx(i, { my: "3", children: /* @__PURE__ */ e.jsx(
              $,
              {
                w: "100%",
                rounded: "2xl",
                color: "white",
                fontSize: "14px",
                colorScheme: "primary",
                h: "auto",
                p: "2",
                onClick: () => o(S),
                children: /* @__PURE__ */ e.jsx(
                  n,
                  {
                    text: M,
                    translationKey: `${h}/payNowBtnLBL`
                  }
                )
              }
            ) }),
            /* @__PURE__ */ e.jsx(
              "hr",
              {
                style: {
                  margin: "8px 0px 12px",
                  border: "none",
                  borderTop: "1px solid #adaaaa"
                }
              }
            )
          ] });
        }) })
      ]
    }
  ) });
}, ue = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzQzIiBoZWlnaHQ9IjIwOCIgdmlld0JveD0iMCAwIDM0MyAyMDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQo8cmVjdCB3aWR0aD0iMzQzIiBoZWlnaHQ9IjIwOCIgcng9IjgiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcl8xNTQ1Ml8yNzk5KSIvPg0KPG1hc2sgaWQ9Im1hc2swXzE1NDUyXzI3OTkiIHN0eWxlPSJtYXNrLXR5cGU6YWxwaGEiIG1hc2tVbml0cz0idXNlclNwYWNlT25Vc2UiIHg9IjAiIHk9IjAiIHdpZHRoPSIzNDMiIGhlaWdodD0iMjA4Ij4NCjxyZWN0IHdpZHRoPSIzNDMiIGhlaWdodD0iMjA4IiByeD0iOCIgZmlsbD0idXJsKCNwYWludDFfbGluZWFyXzE1NDUyXzI3OTkpIi8+DQo8L21hc2s+DQo8ZyBtYXNrPSJ1cmwoI21hc2swXzE1NDUyXzI3OTkpIj4NCjxwYXRoIGQ9Ik0zMTguMDI3IDIzMi4wMzRDMzA4LjAyOSAyNi4wMzQyIC0xNzMuOTc1IC04Ny45NjUgLTEzNi45NzQgMTE3LjAzNkwtMTQuOTc0MiAyMjAuMDM1QzM5LjAyNTggMjU3LjcwMSAzMjYuMTkyIDQwMC4yNzIgMzE4LjAyNyAyMzIuMDM0WiIgZmlsbD0idXJsKCNwYWludDJfbGluZWFyXzE1NDUyXzI3OTkpIiBmaWxsLW9wYWNpdHk9IjAuMSIvPg0KPC9nPg0KPGRlZnM+DQo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfMTU0NTJfMjc5OSIgeDE9IjMyMS4wMjUiIHkxPSIxOC4wNDU3IiB4Mj0iMC45NjQwMDciIHkyPSIyMDQuOTAyIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+DQo8c3RvcCBzdG9wLWNvbG9yPSIjMTYxNjE2Ii8+DQo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiMyNDI0MjQiLz4NCjwvbGluZWFyR3JhZGllbnQ+DQo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MV9saW5lYXJfMTU0NTJfMjc5OSIgeDE9IjMyMS4wMjUiIHkxPSIxOC4wNDU3IiB4Mj0iMC45NjQwMDciIHkyPSIyMDQuOTAyIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+DQo8c3RvcCBzdG9wLWNvbG9yPSIjMTYxNjE2Ii8+DQo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiMyNDI0MjQiLz4NCjwvbGluZWFyR3JhZGllbnQ+DQo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50Ml9saW5lYXJfMTU0NTJfMjc5OSIgeDE9IjI3MS4wMjYiIHkxPSIxMDMuMDM2IiB4Mj0iNS4wMDAwNSIgeTI9IjIwNiIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPg0KPHN0b3Agc3RvcC1jb2xvcj0iI0Q1RDVENSIvPg0KPHN0b3Agb2Zmc2V0PSIwLjc4ODc2MiIgc3RvcC1jb2xvcj0iIzgxODE4MSIgc3RvcC1vcGFjaXR5PSIwIi8+DQo8L2xpbmVhckdyYWRpZW50Pg0KPC9kZWZzPg0KPC9zdmc+DQo=", be = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCA1MiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxnIGlkPSJNYXN0ZXJjYXJkIExvZ28iPg0KPGcgaWQ9Ik1hc3RlckNhcmQgTG9nbyI+DQo8Y2lyY2xlIGlkPSJFbGxpcHNlIDE1IiBjeD0iMzYiIGN5PSIxNiIgcj0iMTYiIGZpbGw9IndoaXRlIiBmaWxsLW9wYWNpdHk9IjAuMjkiLz4NCjxjaXJjbGUgaWQ9IkVsbGlwc2UgMTYiIGN4PSIxNiIgY3k9IjE2IiByPSIxNiIgZmlsbD0id2hpdGUiIGZpbGwtb3BhY2l0eT0iMC42OCIvPg0KPC9nPg0KPC9nPg0KPC9zdmc+DQo=", ai = (g) => {
  const {
    pageTitle: x,
    ccCardLBL: j,
    validCVVLbl: f,
    isInvalidCCNumber: d,
    ccPlaceholder: r,
    ccNumber: s,
    isInvalidCardName: p,
    cardNamePlaceholder: b,
    cardName: D,
    isInvalidexpiryDate: I,
    expiryDatePlaceholder: w,
    expiryDate: C,
    isInvalidCVV: a,
    cvvPlaceholder: y,
    CVV: M,
    saveCardBtnLBL: o,
    handleChange: c,
    onClickSubmit: m,
    handleInputCCNumber: v,
    handleInputCardName: z,
    handleInputexpiryDate: l,
    handleInputCVV: h,
    isDisabled: N,
    ...T
  } = g, L = "AddCard", { data: S } = P(), { theme: W } = S, { colors: B } = W;
  return /* @__PURE__ */ e.jsx(i, { children: /* @__PURE__ */ e.jsxs(
    i,
    {
      ...T,
      p: 2,
      alignItems: "center",
      w: { base: "full", lg: "50%" },
      margin: { base: "0", lg: "auto" },
      pb: { base: "0", lg: "140px" },
      children: [
        /* @__PURE__ */ e.jsx(i, { my: 1, children: x && /* @__PURE__ */ e.jsx(t, { fontSize: { base: "20px", lg: "24px" }, children: /* @__PURE__ */ e.jsx(n, { text: x, translationKey: `${L}/pageTitle` }) }) }),
        /* @__PURE__ */ e.jsxs(i, { position: "relative", w: { base: "full", lg: "50%" }, m: "auto", children: [
          /* @__PURE__ */ e.jsx(R, { src: ue, my: "10px", w: "full" }),
          M ? /* @__PURE__ */ e.jsx(i, { position: "absolute", top: "40%", left: "5%", w: "90%", bg: "white", children: /* @__PURE__ */ e.jsx(t, { color: M ? "black" : "gray", float: "right", px: "2", children: M }) }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
            /* @__PURE__ */ e.jsxs(
              u,
              {
                direction: "row",
                justify: "space-between",
                alignContent: "center",
                position: "absolute",
                top: "8%",
                left: "5%",
                w: "90%",
                children: [
                  /* @__PURE__ */ e.jsx(t, { color: "#FFFFFF", children: /* @__PURE__ */ e.jsx(
                    n,
                    {
                      text: j,
                      translationKey: `${L}/ccCardLBL`
                    }
                  ) }),
                  /* @__PURE__ */ e.jsx(R, { src: be })
                ]
              }
            ),
            /* @__PURE__ */ e.jsx(
              t,
              {
                position: "absolute",
                color: s ? "#FFFFFF" : "gray",
                top: "45%",
                left: "5%",
                children: s || "0000 0000 0000 0000"
              }
            ),
            /* @__PURE__ */ e.jsxs(
              u,
              {
                direction: "row",
                justify: "space-between",
                position: "absolute",
                top: "70%",
                left: "5%",
                w: "90%",
                children: [
                  /* @__PURE__ */ e.jsx(t, { color: D ? "#FFFFFF" : "gray", children: D || "Your name" }),
                  /* @__PURE__ */ e.jsxs(i, { children: [
                    /* @__PURE__ */ e.jsx(t, { color: "#FFFFFF", fontSize: "14px", children: /* @__PURE__ */ e.jsx(t, { children: /* @__PURE__ */ e.jsx(
                      n,
                      {
                        text: f,
                        translationKey: `${L}/validCVVLbl`
                      }
                    ) }) }),
                    /* @__PURE__ */ e.jsx(t, { color: C ? "#FFFFFF" : "gray", children: C || "00/00" })
                  ] })
                ]
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ e.jsx(
          K,
          {
            w: "full",
            isRequired: !1,
            isInvalid: d,
            mb: d ? 1 : 4,
            border: "1px solid gray",
            borderRadius: "8px",
            children: /* @__PURE__ */ e.jsx(
              k,
              {
                style: {
                  padding: "12px",
                  minHeight: "46px",
                  border: "none !important",
                  width: "100%",
                  borderRadius: "8px"
                },
                onChange: (A) => v(A.target.value),
                value: s,
                name: "creditCardNumber",
                placeholder: r,
                options: { creditCard: !0 },
                id: "creditCardNumber",
                type: "tel"
              }
            )
          }
        ),
        d && // <FormErrorMessage>
        /* @__PURE__ */ e.jsx(t, { fontSize: "12px", color: "red", mb: "3", children: /* @__PURE__ */ e.jsx(
          n,
          {
            text: "*Invalid Credit card number",
            translationKey: `${L}/ccNumberErrorMsg`
          }
        ) }),
        /* @__PURE__ */ e.jsx(
          K,
          {
            w: "full",
            isRequired: !1,
            isInvalid: p,
            mb: p ? 1 : 4,
            children: /* @__PURE__ */ e.jsx(
              re,
              {
                type: "text",
                showIcon: !1,
                borderColor: "#A5AAAF",
                placeholder: b || "",
                value: D,
                maxLength: 40,
                onChange: (A) => {
                  z(A.value);
                }
              }
            )
          }
        ),
        p && // <FormErrorMessage>
        /* @__PURE__ */ e.jsx(t, { fontSize: "12px", color: "red", mb: "3", children: /* @__PURE__ */ e.jsx(
          n,
          {
            text: "*Invalid card name",
            translationKey: `${L}/CardNameErrorMsg`
          }
        ) }),
        /* @__PURE__ */ e.jsxs(u, { direction: "row", children: [
          /* @__PURE__ */ e.jsxs(i, { w: "full", children: [
            /* @__PURE__ */ e.jsx(
              K,
              {
                isRequired: !1,
                isInvalid: I,
                mb: I ? 1 : 4,
                mr: "2",
                border: "1px solid gray",
                borderRadius: "8px",
                children: /* @__PURE__ */ e.jsx(
                  k,
                  {
                    style: {
                      padding: "16px 12px",
                      minHeight: "46px",
                      border: "none !important",
                      width: "100%",
                      borderRadius: "8px"
                    },
                    value: C,
                    placeholder: w,
                    options: { date: !0, datePattern: ["m", "d"] },
                    onChange: (A) => l(A)
                  }
                )
              }
            ),
            I && /* @__PURE__ */ e.jsx(t, { fontSize: "12px", color: "red", mb: "3", children: /* @__PURE__ */ e.jsx(
              n,
              {
                text: "*Invalid expiry date",
                translationKey: `${L}/expiryDateErrorMsg`
              }
            ) })
          ] }),
          /* @__PURE__ */ e.jsxs(i, { w: "full", children: [
            /* @__PURE__ */ e.jsx(
              K,
              {
                w: "full",
                isRequired: !1,
                isInvalid: a,
                mb: a ? 1 : 4,
                ml: "2",
                border: "1px solid gray",
                borderRadius: "8px",
                children: /* @__PURE__ */ e.jsx(
                  k,
                  {
                    type: "password",
                    style: {
                      padding: "16px 12px",
                      minHeight: "46px",
                      border: "none !important",
                      width: "100%",
                      borderRadius: "8px"
                    },
                    placeholder: y,
                    value: M,
                    options: {
                      blocks: [3],
                      numericOnly: !0
                    },
                    onChange: (A) => h(A),
                    className: "form-field"
                  }
                )
              }
            ),
            a && /* @__PURE__ */ e.jsx(t, { fontSize: "12px", color: "red", mb: "3", children: /* @__PURE__ */ e.jsx(
              n,
              {
                text: "*Invalid security code",
                translationKey: `${L}/CVVErrorMsg`
              }
            ) })
          ] })
        ] }),
        /* @__PURE__ */ e.jsx(i, { w: { base: "full", lg: "50%" }, m: "20px auto", children: /* @__PURE__ */ e.jsx(
          $,
          {
            w: "full",
            color: "white",
            colorScheme: "primary",
            bg: N ? "gray.200" : B.primary,
            cursor: N ? "not-allowed" : "pointer",
            disabled: N,
            onClick: () => N ? void 0 : m && m(),
            children: /* @__PURE__ */ e.jsx(n, { text: o, translationKey: "Global/Submit" })
          }
        ) })
      ]
    }
  ) });
}, { useState: O } = pe, xi = ({
  CCNumber: g,
  ExpiryDate: x,
  inputCVV: j,
  CCName: f,
  getAllCCdata: d
}) => {
  const [r, s] = O({
    isInvalidInputCCNumberValue: !1,
    isInvalidInputExpiryValue: !1,
    isInvalidInputCVVValue: !1,
    isInvalidInputCCNameValue: !1
  }), [p, b] = O({
    cardNumber: "",
    expDate: "",
    cvv: "",
    name: ""
  });
  he(() => {
    d(r, p);
  }, [r, p]);
  const D = (o) => {
    const c = o.replace(/\s/g, "");
    return c.length < 15 || c.length > 16 ? (s({ ...r, isInvalidInputCCNumberValue: !0 }), !1) : (b({ ...p, cardNumber: o }), s({ ...r, isInvalidInputCCNumberValue: !1 }), !0);
  }, I = {
    VISA: "../assets/img-visa2.png",
    MASTER: "../assets/img-master-2.png",
    MASTERCARD: "../assets/img-master-2.png"
  }, w = {
    VISA: /^4[0-9]{12}(?:[0-9]{3})?$/,
    MASTER: /^5[1-5][0-9]{14}$/,
    MASTERCARD: /^5[1-5][0-9]{14}$/
  }, C = (o) => {
    const c = o && o.split(" ").join("");
    let m = Object.keys(w).find((v) => w[v].test(c) ? (b({ ...p, cardNumber: c }), s({ ...r, isInvalidInputCCNumberValue: !1 }), !0) : (s({ ...r, isInvalidInputCCNumberValue: !0 }), !1));
    return {
      CardType: m,
      CardImg: I[m]
    };
  }, a = (o) => {
    var c, m, v, z;
    if (o) {
      const l = o.split("/");
      if (l.length !== 2)
        return s({ ...r, isInvalidInputExpiryValue: !0 }), !1;
      const h = parseInt(l[0], 10), N = parseInt(l[1], 10), T = (/* @__PURE__ */ new Date()).getFullYear(), L = Number(
        ((m = (c = T == null ? void 0 : T.toString()) == null ? void 0 : c.split("")) == null ? void 0 : m[2]) + ((z = (v = T == null ? void 0 : T.toString()) == null ? void 0 : v.split("")) == null ? void 0 : z[3])
      ), S = (/* @__PURE__ */ new Date()).getMonth() + 1;
      return isNaN(h) || isNaN(N) ? (s({ ...r, isInvalidInputExpiryValue: !0 }), !1) : N > L + 10 ? (s({ ...r, isInvalidInputExpiryValue: !0 }), !1) : N === L && h >= S ? (b({ ...p, expDate: o }), s({ ...r, isInvalidInputExpiryValue: !1 }), !0) : N > L || N === L && h > S ? (b({ ...p, expDate: o }), s({ ...r, isInvalidInputExpiryValue: !1 }), !0) : (s({ ...r, isInvalidInputExpiryValue: !0 }), !1);
    } else
      return b({ ...p, expDate: o }), s({ ...r, isInvalidInputExpiryValue: !0 }), !1;
  }, y = (o) => {
    !isNaN(o) && o.length === 3 ? s({ ...r, isInvalidInputCVVValue: !1 }) : s({ ...r, isInvalidInputCVVValue: !0 }), b({ ...p, cvv: o });
  }, M = (o) => {
    /^([a-zA-Z-]+\s)*[a-zA-Z-]+$/i.test(o) ? s({ ...r, isInvalidInputCCNameValue: !1 }) : s({ ...r, isInvalidInputCCNameValue: !0 }), b({ ...p, name: o });
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs(K, { isInvalid: r.isInvalidInputCCNumberValue, py: 2, children: [
      /* @__PURE__ */ e.jsx(
        k,
        {
          options: { creditCard: !0 },
          style: {
            border: r.isInvalidInputCCNumberValue ? "1px solid red" : "1px solid #6E767D",
            padding: "8px",
            borderRadius: "4px",
            width: "100%",
            height: "50px"
          },
          type: "text",
          inputMode: "numeric",
          required: !0,
          placeholder: g.placeholder,
          name: g.key,
          value: p.cardNumber,
          onChange: (o) => {
            D(o.target.value), C(o.target.value);
          }
        }
      ),
      /* @__PURE__ */ e.jsx(V, { children: g.errormsg })
    ] }),
    /* @__PURE__ */ e.jsxs(ee, { justify: "between", width: "full", children: [
      /* @__PURE__ */ e.jsxs(K, { isInvalid: r.isInvalidInputExpiryValue, py: 2, children: [
        /* @__PURE__ */ e.jsx(
          k,
          {
            options: { date: !0, datePattern: ["m", "Y"] },
            style: {
              border: r.isInvalidInputExpiryValue ? "1px solid red" : "1px solid #6E767D",
              padding: "8px",
              borderRadius: "4px",
              width: "95%",
              height: "50px"
            },
            type: "text",
            required: !0,
            placeholder: x.placeholder,
            name: x.key,
            value: p.expDate,
            onChange: (o) => {
              a(o.target.value);
            }
          }
        ),
        /* @__PURE__ */ e.jsx(V, { children: x.errormsg })
      ] }),
      /* @__PURE__ */ e.jsxs(K, { isInvalid: r.isInvalidInputCVVValue, py: 2, children: [
        /* @__PURE__ */ e.jsx(
          Q,
          {
            style: {
              border: r.isInvalidInputCVVValue ? "1px solid red" : "1px solid #6E767D",
              padding: "8px",
              borderRadius: "4px",
              width: "100%",
              height: "50px"
            },
            type: "password",
            value: p.cvv,
            onChange: (o) => {
              y(o.target.value);
            },
            minLength: 3,
            maxLength: 3,
            placeholder: j.placeholder
          }
        ),
        /* @__PURE__ */ e.jsx(V, { children: j.errormsg })
      ] })
    ] }),
    /* @__PURE__ */ e.jsxs(K, { isInvalid: r.isInvalidInputCCNameValue, py: 2, children: [
      /* @__PURE__ */ e.jsx(
        Q,
        {
          style: {
            border: r.isInvalidInputCCNameValue ? "1px solid red" : "1px solid #6E767D",
            padding: "8px",
            borderRadius: "4px",
            width: "100%",
            height: "50px"
          },
          name: f.key,
          value: p.name,
          onChange: (o) => M(o.target.value),
          minLength: 12,
          maxLength: 40,
          type: "text",
          placeholder: f.placeholder
        }
      ),
      /* @__PURE__ */ e.jsx(V, { children: f.errormsg })
    ] })
  ] });
}, ci = (g) => {
  const {
    pageTitle: x,
    title: j,
    heading: f,
    doNotRenewText: d,
    renewOptions: r,
    handleOptionChange: s,
    isDisabled: p,
    btnSubmitLBL: b,
    onClickSubmit: D,
    selectedOption: I,
    handleDonotRenew: w,
    ...C
  } = g, a = "Renewal", { data: y } = P(), { theme: M } = y, { colors: o } = M, { bodyTextColor: c } = o;
  return /* @__PURE__ */ e.jsxs(i, { position: "relative", h: "85vh", w: "full", children: [
    /* @__PURE__ */ e.jsxs(
      i,
      {
        ...C,
        p: 2,
        alignItems: "center",
        w: { base: "full", lg: "70%" },
        margin: { base: "0", lg: "auto" },
        pb: { base: "0", lg: "20px" },
        children: [
          /* @__PURE__ */ e.jsx(i, { my: 1, children: j && /* @__PURE__ */ e.jsx(t, { fontWeight: 700, children: /* @__PURE__ */ e.jsx(n, { text: j, translationKey: `${a}/title` }) }) }),
          /* @__PURE__ */ e.jsx(
            xe,
            {
              value: I,
              my: "5",
              w: { base: "full", lg: "50%" },
              mx: "auto",
              children: /* @__PURE__ */ e.jsx(G, { children: r == null ? void 0 : r.map((m, v) => /* @__PURE__ */ e.jsx(
                i,
                {
                  borderWidth: "1px",
                  borderRadius: "md",
                  borderColor: m == I ? c : "#A5AAAF",
                  border: m == I ? "2px" : "",
                  p: 4,
                  mb: 4,
                  onChange: () => {
                    s(m);
                  },
                  children: /* @__PURE__ */ e.jsxs(
                    ce,
                    {
                      fontSize: "20px",
                      size: "lg",
                      value: m,
                      colorScheme: "primary",
                      children: [
                        /* @__PURE__ */ e.jsx(t, { children: /* @__PURE__ */ e.jsx(
                          n,
                          {
                            text: m == null ? void 0 : m.name,
                            translationKey: `${a}/renewalOption${v + 1}`
                          }
                        ) }),
                        /* @__PURE__ */ e.jsx(t, { fontSize: "14px", children: m == null ? void 0 : m.discount })
                      ]
                    },
                    m
                  )
                },
                m
              )) })
            }
          ),
          /* @__PURE__ */ e.jsx(u, { justify: "center", children: /* @__PURE__ */ e.jsx(
            $,
            {
              variant: "link",
              colorScheme: o.primary,
              color: o.primary,
              onClick: () => w(),
              textAlign: "center",
              textDecoration: "underline",
              children: /* @__PURE__ */ e.jsx(t, { fontWeight: 700, children: /* @__PURE__ */ e.jsx(
                n,
                {
                  text: d,
                  translationKey: `${a}/doNotRenewText`
                }
              ) })
            }
          ) })
        ]
      }
    ),
    /* @__PURE__ */ e.jsx(u, { w: "full", position: "absolute", bottom: "0px", m: "auto", children: /* @__PURE__ */ e.jsx(
      $,
      {
        w: { base: "full", lg: "30%" },
        m: "auto",
        color: "white",
        colorScheme: "primary",
        bg: p ? "gray.200" : o.primary,
        cursor: p ? "not-allowed" : "pointer",
        disabled: p,
        onClick: () => p ? void 0 : D && D(),
        children: b && /* @__PURE__ */ e.jsx(n, { text: b, translationKey: "Global/Submit" })
      }
    ) })
  ] });
}, di = (g) => {
  const {
    heading: x,
    plan: j,
    priceLBL: f,
    mdn: d,
    priceValue: r,
    prevPriceValue: s,
    nextBillingDateLBL: p,
    nextBillingDateValue: b,
    showSwitchSection: D,
    switchToSaveText: I,
    switchText: w,
    handleSwitchClick: C,
    paymentMethodLBL: a,
    cardNumber: y,
    cardImage: M,
    changeText: o,
    handleChange: c,
    btnConfirmLBL: m,
    // isDisabled,
    onClickSubmit: v,
    ...z
  } = g, l = "RenewalConfirmation", { data: h } = P(), { theme: N } = h, { colors: T } = N;
  return me(), /* @__PURE__ */ e.jsx(i, { h: "85vh", children: /* @__PURE__ */ e.jsxs(
    i,
    {
      ...z,
      p: 2,
      alignItems: "center",
      w: "full",
      margin: { base: "0", lg: "auto" },
      pb: { base: "0", lg: "140px" },
      children: [
        /* @__PURE__ */ e.jsx(i, { my: 1, children: x && /* @__PURE__ */ e.jsx(t, { fontSize: "24px", children: /* @__PURE__ */ e.jsx(n, { text: x, translationKey: `${l}/heading` }) }) }),
        /* @__PURE__ */ e.jsx(i, { my: 1, children: j && /* @__PURE__ */ e.jsx(t, { fontSize: "18px", children: /* @__PURE__ */ e.jsx(n, { text: j, translationKey: `Global/${j}` }) }) }),
        /* @__PURE__ */ e.jsx(i, { fontWeight: "700", my: 1, fontSize: "32px", children: /* @__PURE__ */ e.jsx(t, { children: d }) }),
        /* @__PURE__ */ e.jsxs(u, { direction: "row", justify: "space-between", children: [
          /* @__PURE__ */ e.jsxs(u, { direction: "column", children: [
            /* @__PURE__ */ e.jsx(t, { fontWeight: "700", fontSize: "18px", children: /* @__PURE__ */ e.jsx(n, { text: f, translationKey: `${l}/priceLBL` }) }),
            s && /* @__PURE__ */ e.jsx(t, { fontSize: "18px", children: /* @__PURE__ */ e.jsx("del", { children: s }) }),
            /* @__PURE__ */ e.jsx(t, { fontSize: "18px", children: r })
          ] }),
          /* @__PURE__ */ e.jsxs(u, { direction: "column", children: [
            /* @__PURE__ */ e.jsx(t, { fontWeight: "700", fontSize: "18px", children: /* @__PURE__ */ e.jsx(
              n,
              {
                text: p,
                translationKey: `${l}/nextBillingDateLBL`
              }
            ) }),
            /* @__PURE__ */ e.jsx(t, { fontSize: "18px", children: b })
          ] })
        ] }),
        /* @__PURE__ */ e.jsx(
          "hr",
          {
            style: {
              margin: "8px -8px 12px -8px",
              border: "none",
              borderTop: "1px solid #adaaaa"
            }
          }
        ),
        D && /* @__PURE__ */ e.jsxs(
          u,
          {
            direction: "row",
            justify: "space-between",
            p: "3",
            bg: "#F0F0F5",
            borderRadius: "10px",
            align: "center",
            children: [
              /* @__PURE__ */ e.jsx(t, { fontWeight: "700", children: /* @__PURE__ */ e.jsx(
                n,
                {
                  text: I,
                  translationKey: `${l}/switchToSaveText`
                }
              ) }),
              /* @__PURE__ */ e.jsx(
                i,
                {
                  py: "1",
                  px: "3",
                  border: `1px solid ${T.primary}`,
                  borderRadius: "10px",
                  onClick: () => C(),
                  cursor: "pointer",
                  h: "auto",
                  children: /* @__PURE__ */ e.jsx(t, { fontWeight: "700", color: T.primary, children: /* @__PURE__ */ e.jsx(
                    n,
                    {
                      text: w,
                      translationKey: `${l}/switchText`
                    }
                  ) })
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ e.jsx(i, { mt: "4", mb: 2, children: a && /* @__PURE__ */ e.jsx(t, { fontWeight: "700", fontSize: "18px", children: /* @__PURE__ */ e.jsx(
          n,
          {
            text: a,
            translationKey: `${l}/paymentMethodLBL`
          }
        ) }) }),
        /* @__PURE__ */ e.jsx(i, { my: 1, children: /* @__PURE__ */ e.jsxs(u, { direction: "row", justify: "space-between", children: [
          /* @__PURE__ */ e.jsxs(u, { direction: "row", children: [
            /* @__PURE__ */ e.jsx(t, { fontSize: "18px", children: y }),
            M && M
          ] }),
          /* @__PURE__ */ e.jsx(
            t,
            {
              fontWeight: "700",
              fontSize: "18px",
              textDecorationLine: "underline",
              color: T.primary,
              cursor: "pointer",
              onClick: (L) => c(L),
              children: /* @__PURE__ */ e.jsx(
                n,
                {
                  text: o,
                  translationKey: `${l}/changeText`
                }
              )
            }
          )
        ] }) }),
        /* @__PURE__ */ e.jsx(
          i,
          {
            w: { base: "90%", lg: "75%" },
            style: {
              position: "absolute",
              bottom: "0px",
              // width: `calc(100% - 50px)`,
              display: "flex",
              justifyContent: "center"
            },
            children: /* @__PURE__ */ e.jsx(
              $,
              {
                color: "white",
                colorScheme: "primary",
                onClick: () => v(),
                w: { base: "full", lg: "30%" },
                children: m && /* @__PURE__ */ e.jsx(n, { text: m, translationKey: "Global/Confirm" })
              }
            )
          }
        )
      ]
    }
  ) });
}, pi = ({ highfive: g, onCancelClick: x, pageName: j = "ConfirmDeviceRegistration" }) => (P(), /* @__PURE__ */ e.jsx(i, { children: /* @__PURE__ */ e.jsx(i, { w: { base: "full", lg: "80%" }, margin: "auto", pt: "50px", children: /* @__PURE__ */ e.jsx(i, { children: /* @__PURE__ */ e.jsxs(
  i,
  {
    id: "myasurion-profile-avatar",
    w: { base: "full", lg: "80%" },
    margin: "0 auto",
    h: "auto",
    p: "1rem",
    textAlign: "center",
    children: [
      /* @__PURE__ */ e.jsx(R, { marginX: "auto", src: g, alt: "your model" }),
      /* @__PURE__ */ e.jsx(t, { mt: "5", fontSize: { base: "2xl", lg: "3xl" }, children: /* @__PURE__ */ e.jsx(
        n,
        {
          text: "Thank you for registering",
          translationKey: `${j}/header`
        }
      ) }),
      /* @__PURE__ */ e.jsx(t, { mt: "5", whiteSpace: "pre-line", children: /* @__PURE__ */ e.jsx(
        n,
        {
          text: "Please follow the instructions to complete your personal and all device info registering. After registered, you can check main page for the coverage check or service track.",
          translationKey: `${j}/subHeader`
        }
      ) }),
      /* @__PURE__ */ e.jsx(
        i,
        {
          position: "fixed",
          bottom: "0",
          left: "0",
          right: "0",
          width: "full",
          bg: "white",
          p: 4,
          style: { boxShadow: "0px -4px 4px 0px rgba(0, 0, 0, 0.08)" },
          children: /* @__PURE__ */ e.jsx(
            $,
            {
              my: "5",
              textAlign: "center",
              colorScheme: "primary",
              variant: "link",
              cursor: "pointer",
              onClick: x,
              textDecoration: "underline",
              children: /* @__PURE__ */ e.jsx(
                n,
                {
                  text: "Go back to home",
                  translationKey: `${j}/goBackBtn`
                }
              )
            }
          )
        }
      )
    ]
  }
) }) }) }));
export {
  ai as AddCard,
  Li as AvatarInitials,
  Wi as BackButton,
  si as BillingDetails,
  bt as Button,
  Wt as CSAT,
  tt as Cards,
  li as ChangeAddress,
  $t as CognitoAuthProvider,
  pi as ConfirmDeviceRegistration,
  at as ConfirmationAfterSubmission,
  ji as CreatePasswordSchema,
  xi as Creditcard,
  gi as CustomerSupportFooter,
  pt as DeliveryDetails,
  ct as DeliveryOptions,
  ui as DesktopView,
  ki as DeviceCard,
  ft as DeviceModel,
  Hi as DeviceService,
  ot as DeviceSpecification,
  Bi as Faq,
  Qt as GoogleSignInButton,
  bi as Header,
  Ei as HelloWorld,
  ti as ImeiConfirmation,
  ii as ImeiDetails,
  Pi as Input,
  yi as LanguageSelector,
  ht as LogisticsAndFulfilment,
  fi as MenuButton,
  Ii as MenuDisplay,
  wi as MobileView,
  oi as MyPayments,
  Lt as NPS,
  zt as NPSReasons,
  Tt as NPSSlider,
  mt as NewAddress,
  Ht as OTPInput,
  Ci as PASSWORDFORM,
  Si as PasswordResetForm,
  Mi as PasswordResetSchema,
  Gt as PaymentCCIcon,
  qi as PaymentForm,
  jt as PickupSchedule,
  Rt as ProfileIcon,
  Ti as ProtectedLayout,
  ci as Renewal,
  di as RenewalConfirmation,
  Ji as ReviewSubmission,
  ei as ReviewUpdateDevice,
  ni as SelectCapacity,
  ri as SelectColor,
  Di as SignOutLink,
  rt as SmartStock,
  gt as StoreSelection,
  Ai as SubHeader,
  Mt as SubmitDeclaration,
  Xi as SubmitRequest,
  et as TermsAndCondition,
  Vt as TextEditIcon,
  re as TextInput,
  n as TextScript,
  n as TextString,
  Zi as TextTranslation,
  Nt as TriageQuestion,
  _e as UpdateDevice,
  wt as VideoDeclaration,
  Ct as VideoPlayer,
  Kt as ViewDocument,
  Ni as getTextScript
};
